import { FC } from 'react';
import { useClassNamesWithStyle } from '@edikk-edikk/country-frontend';
import homeBackgroundCss from './assets/home-background.module.scss';
import { BackgroundGradient, BackgroundImageDefault, BackgroundImageDynamic } from '#home/components';

const Background: FC = () => {
  const classNamesWithStyle = useClassNamesWithStyle();

  return (
    <div
      className={classNamesWithStyle(
        homeBackgroundCss.homeBackground,
        homeBackgroundCss.homeBackground_styleDefault,
      )}
    >
      <BackgroundGradient />
      <BackgroundImageDynamic />
      <BackgroundImageDefault />
    </div>
  );
};

export { Background };
